// G1-F: production history detail helpers (pure, tested by Jest).

export function ringkasCeklis(c) {
  if (!c || !c.terisi) return { teks: "Belum ada data", lengkap: false };
  const lengkap = c.total > 0 && c.ok === c.total;
  if (c.total === 0) return { teks: "Tanpa checklist", lengkap: true };
  return { teks: `${c.ok} dari ${c.total} checklist OK${lengkap ? " · lengkap" : ""}`, lengkap };
}

export function nilaiButir(b) {
  if (b.tipe === "TEKS") return b.nilai ? String(b.nilai) : "—";
  if (b.nilai === null || b.nilai === undefined) return "—";
  return b.nilai ? "✓ OK" : "✗ Tidak";
}

// "SUDAH ADA DATA" / "BELUM ADA DATA" label of one stage.
export const labelData = (t) => (t.ada_data ? "SUDAH ADA DATA" : "BELUM ADA DATA");
